import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext } from "react";
export const FormDisabledContext = /*#__PURE__*/ createContext({
    isDisabled: false
});
export const FormDisabledProvider = ({ isDisabled, children })=>{
    return /*#__PURE__*/ _jsx(FormDisabledContext.Provider, {
        value: {
            isDisabled
        },
        children: children
    });
};
export const useIsDisabled = ()=>useContext(FormDisabledContext);
